export const CateringStatus = {
    PREREGISTER:"سفارش به زودی",
    ACTIVE:"سفارش دهید",
    INACTIVE:"غیر فعال",
}
